import { iIconProps } from '../../icon';

export default function FacebookIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 40 40' {...props}>
            <path d='M25.079 9.313H28V4.225C27.496 4.156 25.763 4 23.744 4c-4.212 0-7.097 2.65-7.097 7.519V16h-4.648v5.688h4.648V36h5.699V21.69h4.46L27.514 16h-5.17v-3.918c.002-1.644.444-2.77 2.735-2.77z' />
        </svg>
    );
}
